// @flow
import { camelize } from 'utils/camelize'
import { Api } from 'core/services/api'
import type { NavCounts } from './types'

export const menuApi = {
  fetchCounts: (): Promise<NavCounts> => Api.get('/api/menu/counters').then(({ data }): NavCounts => camelize(data)),
}
